import { useState } from "react";
import Funnel from "./components/Funnel/Funnel";
import SuccessMessage from "./components/Funnel/SuccessMessage";

type Status = "form" | "success" | "error";

/**
 * Wrapper racine du widget. Gère la bascule form → success/error.
 * Le Funnel lui-même se cache quand le statut n'est pas "form" ; on affiche
 * alors le message correspondant.
 */
interface EmbedRootProps {
  produits?: string;
  variant?: string;
  localisation?: string;
}

export default function EmbedRoot({ produits, variant, localisation }: EmbedRootProps) {
  const [status, setStatus] = useState<Status>("form");

  return (
    <>
      {status === "form" && (
        <Funnel
          onStatusChange={setStatus}
          produits={produits}
          variant={variant}
          localisation={localisation}
        />
      )}
      {status === "success" && <SuccessMessage />}
      {status === "error" && (
        <div style={{ textAlign: "center", padding: "30px 20px" }}>
          <h3 style={{ marginBottom: 12 }}>
            Une erreur est survenue lors de l&apos;envoi de votre demande.
          </h3>
          <p>Veuillez réessayer ultérieurement.</p>
        </div>
      )}
    </>
  );
}
